import {Component, OnInit, Input, HostListener, ViewChild, ElementRef } from '@angular/core';
import {DataService} from '../../../core/services/data.service';
import {CounterParty, User} from '../../../core/models/User';
import { switchMap, filter } from 'rxjs/operators';
import {ActivatedRoute, Router, RoutesRecognized} from '@angular/router';
import {Store} from '../../../store';
import * as _ from 'underscore';
import { LegalEntity } from '../../../core/models/LegalEntity';

@Component({
    selector: 'app-nav',
    templateUrl: './app-nav.component.html',
    styleUrls: ['./app-nav.component.scss'],
    standalone: false
})
export class AppNavComponent implements OnInit {
    selectedEntityId: string;
    counterParties: string[];
    @Input() legalEntities: LegalEntity[];
    user: User;
    entityTailConfigs: any;
    showMenu: boolean = false;
    @ViewChild('nav', {static: true}) nav: ElementRef;  
    expanded = false;
    truncated: string[] = [];
    visibleItems = {};
    entityDropdownVisibility: string = 'hidden';
    entityDropdownTimer: any = null;
    constructor(private dataService: DataService, private route: ActivatedRoute, private router: Router, private store: Store) {
    }

    ngOnInit() {
        
        this.legalEntities = [
            {
               "entityId":"E3",
               "dataName":"AIAI - HK (NPar)",
               "name":"HK (NPar)",
               "code":"HK (NPar)",
               "counterParties":[
                  "ALL"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E12",
               "dataName":"AIAI - HK (Par H UST)",
               "name":"HK (Par H UST)",
               "code":"HK (Par H UST)",
               "counterParties":[
                  "ALL"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E17",
               "dataName":"AIAI - HK (Par M)",
               "name":"HK (Par M)",
               "code":"HK (Par M)",
               "counterParties":[
                  "ALL"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E16",
               "dataName":"AIAI - HK (Par M UST)",
               "name":"HK (Par M UST)",
               "code":"HK (Par M UST)",
               "counterParties":[
                  "ALL"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E15",
               "dataName":"AIAI - HK (Par L)",
               "name":"HK (Par L)",
               "code":"HK (Par L)",
               "counterParties":[
                  "ALL"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E10",
               "dataName":"AIA Singapore (Par)",
               "name":"Singapore (Par)",
               "code":"SG (Par)",
               "counterParties":[
                  "NDBS",
                  "DBS"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E13",
               "dataName":"AIAI - HK (Par H)",
               "name":"HK (Par H)",
               "code":"HK (Par H)",
               "counterParties":[
                  "ALL"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E1",
               "dataName":"AIA Singapore (NPar)",
               "name":"Singapore (NPar)",
               "code":"SG (NPar)",
               "counterParties":[
                  "NDBS",
                  "DBS"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E5",
               "dataName":"AIA Australia",
               "name":"Australia",
               "code":"AUS",
               "counterParties":[
                  "ALL"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E22",
               "dataName":"AIAI - KOREA (GA)",
               "name":"Korea (GA)",
               "code":"KOREA (GA)",
               "counterParties":[
                  "ALL"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E11",
               "dataName":"AIA CO LTD - SF",
               "name":"SF",
               "code":"SF",
               "counterParties":[
                  "ALL"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E31",
               "dataName":"AIA PH (NPar)",
               "name":"PH (NPar)",
               "code":"PH (NPar)",
               "counterParties":[
                  "ALL"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E18",
               "dataName":"AIAI - HK (Par X UST)",
               "name":"HK (Par X UST)",
               "code":"HK (Par X UST)",
               "counterParties":[
                  "ALL"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E2",
               "dataName":"AIA Group",
               "name":"Group",
               "code":"GROUP",
               "counterParties":[
                  "ALL"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E7",
               "dataName":"AIA Thailand",
               "name":"Thailand",
               "code":"THAI",
               "counterParties":[
                  "ALL"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E21",
               "dataName":"AIAI - KOREA (AL)",
               "name":"Korea (AL)",
               "code":"KOREA (AL)",
               "counterParties":[
                  "ALL"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E9",
               "dataName":"AIAI - HO",
               "name":"HO",
               "code":"HO",
               "counterParties":[
                  "Citigroup",
                  "HSBC",
                  "BNP Paribas"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E32",
               "dataName":"AIA MY",
               "name":"MY",
               "code":"MY",
               "counterParties":[
                  "ALL"
               ],
               "ccrOrExpo":1
            },
            {
               
               "entityId":"E19",
               "dataName":"AIAI - HK (Par X)",
               "name":"HK (Par X)",
               "code":"HK (Par X)",
               "counterParties":[
                  "ALL"
               ],
               "ccrOrExpo":1
            }
        ];
        this.subscribeUserProfileChange();
        this.router.events.subscribe(val => {
            if (val instanceof RoutesRecognized) {
                this.selectedEntityId = decodeURIComponent(val.state.root.firstChild.params.entityId);
                this.getCounterParties();
                this.scrollToTop();
            }
        });
    }

    showSecondaryMenu(): boolean {
        return this.router.url !== '/overview' && this.selectedEntityId && this.counterParties && this.counterParties.length > 0;
    }

    private subscribeUserProfileChange() {
        this.store.select<User>('user')
            .pipe(
                filter(Boolean)
            )
            .subscribe((user:User) => {
                if (!user.queryConfig || !user.queryConfig.entityTailConfigs ) {
                    return;
                }
                this.user = user;
                this.entityTailConfigs = user.queryConfig.entityTailConfigs;
                if (!this.counterParties) {
                    this.getCounterParties();
                }

            });
    }

    public getCounterParties() {
        if (!this.user || !this.entityTailConfigs || !this.selectedEntityId) {
            return;
        }
        const selectedEntity = _.find(this.user.legalEntities, x => {
            return x.entityId === this.selectedEntityId;
        });

        if (selectedEntity) {
            this.counterParties = selectedEntity.counterParties;
        }
    }

    public scrollToTop() {
        window.scrollTo(0, 0);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.setupLocations();
    }

    setupLocations() {
        if (this.nav && this.nav.nativeElement && this.nav.nativeElement.children && this.nav.nativeElement.children.item(1)) {
            const top = this.nav.nativeElement.children.item(1).getBoundingClientRect().top;
            for (const element of this.nav.nativeElement.children) {
                this.visibleItems[element.innerText.trim().toUpperCase()] = (element.getBoundingClientRect().top !== top);
            }
        }
    }

    visible(text: string): boolean {
        const str = text.trim();
        const ret = this.visibleItems[str.toUpperCase()] === true;
        return ret;
    }
    /**
     * Display the entity dropdown after a small delay.
     *
     * @memberof AppNavComponent
     */
    delayedDisplay() {
        if (this.entityDropdownTimer) {
            clearTimeout(this.entityDropdownTimer);
        }
        this.entityDropdownTimer = setTimeout(() => {
            this.entityDropdownVisibility = 'visible';
        }, 250);
    }
    /**
     * Hide the entity dropdown immediately
     *
     * @memberof AppNavComponent
     */
    undisplay() {
        if (this.entityDropdownTimer) {
            clearTimeout(this.entityDropdownTimer);
            this.entityDropdownTimer = null;
        }
        this.entityDropdownVisibility = 'hidden';
    }
}
